(() => {
    const tags = document.querySelectorAll('.tag:not(.in-details)');

    const addBorder = () => {
        tags.forEach(tag => {
            tag.setAttribute('style', `border-color: ${tag.dataset.color}`);

            if(document.querySelector('.hp-news__list') && document.querySelector('.hp-news__list').contains(tag)) {
                tag.style.backgroundColor = tag.dataset.color;
            }

            if(document.querySelector('.hp-events__list') && document.querySelector('.hp-events__list').contains(tag)) {
                tag.style.backgroundColor = tag.dataset.color;
            }
        });
    }

    const init = () => {
        if(tags.length > 0) {
            addBorder();
        }
    }

    init();
})();